var _rect, _path, _path2, _circle, _rect2, _path3, _path4, _path5, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 51C131 63.1503 121.15 73 109 73C96.8497 73 87 63.1503 87 51C87 38.8497 96.8497 29 109 29C121.15 29 131 38.8497 131 51Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 69C118.941 69 127 60.9411 127 51C127 41.0589 118.941 33 109 33C99.0589 33 91 41.0589 91 51C91 60.9411 99.0589 69 109 69ZM109 73C121.15 73 131 63.1503 131 51C131 38.8497 121.15 29 109 29C96.8497 29 87 38.8497 87 51C87 63.1503 96.8497 73 109 73Z",
    fill: "#4C6170"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 51,
    r: 12,
    fill: "#4C6170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 46,
    width: 87,
    height: 12,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131 103C131 115.15 121.15 125 109 125C96.8497 125 87 115.15 87 103C87 90.8497 96.8497 81 109 81C121.15 81 131 90.8497 131 103Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 121C118.941 121 127 112.941 127 103C127 93.0589 118.941 85 109 85C99.0589 85 91 93.0589 91 103C91 112.941 99.0589 121 109 121ZM109 125C121.15 125 131 115.15 131 103C131 90.8497 121.15 81 109 81C96.8497 81 87 90.8497 87 103C87 115.15 96.8497 125 109 125Z",
    fill: "#4C6170"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147 98H234V110H147V98Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#B4DDEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioGroup);
export default __webpack_public_path__ + "static/media/radio-group.e6f9c67a3548a4871771a1a23fa89b0b.svg";
export { ForwardRef as ReactComponent };